import { render, staticRenderFns } from "./updatePhy.vue?vue&type=template&id=f49ab72c&"
import script from "./updatePhy.vue?vue&type=script&lang=js&"
export * from "./updatePhy.vue?vue&type=script&lang=js&"
import style0 from "./updatePhy.vue?vue&type=style&index=0&id=f49ab72c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports